import { DEFAULT_THEME, EmailDocument, HOTELSPOT_LOGO_URL } from '../model/types';
import type { TemplateDraft } from './useGenerateTemplateDraft';

/**
 * Szkic z AI w układ bloków.
 *
 * AI dostarcza tytuł i treść, a strukturę wiadomości (logo, linia, akapity, przycisk,
 * podpis, stopka) narzucamy my. Model nie musi wtedy znać naszego formatu, a każda
 * wygenerowana wiadomość wygląda tak samo jak reszta korespondencji z panelu.
 */
export const buildDraftDocument = (prompt: string, draft: TemplateDraft): EmailDocument => {
  const paragraphs = draft.description.trim();

  return {
    name: draft.title || 'Szablon z AI',
    subject: draft.title || 'Wiadomość od hotelspot',
    /* Zajawka z pierwszego zdania: skrzynka pokazuje ją obok tematu, a puste pole
       wypełniłaby początkiem treści, czyli zwykle powitaniem. */
    preheader: paragraphs.split(/(?<=[.!?])\s/)[0]?.slice(0, 120) ?? prompt.slice(0, 120),
    theme: { ...DEFAULT_THEME },
    blocks: [
      { id: 'ai-0', kind: 'logo', src: HOTELSPOT_LOGO_URL, alt: 'hotelspot', height: 26, align: 'left' },
      { id: 'ai-1', kind: 'heading', text: draft.title, level: 1, align: 'left' },
      { id: 'ai-2', kind: 'divider' },
      { id: 'ai-3', kind: 'text', text: `Cześć {{firstName}},\n\n${paragraphs}`, align: 'left', small: false },
      { id: 'ai-4', kind: 'button', label: 'Otwórz panel', href: '{{panelUrl}}', align: 'left', fullWidth: false },
      { id: 'ai-5', kind: 'text', text: 'Zespół hotelspot', align: 'left', small: true },
      { id: 'ai-6', kind: 'divider' },
      {
        id: 'ai-7',
        kind: 'footer',
        text: 'Wiadomość od hotelspot do administratorów obiektu {{hotelName}}.',
        unsubscribeUrl: '{{unsubscribeUrl}}',
        unsubscribeLabel: 'Nie chcę takich wiadomości',
      },
    ],
  };
};
